import { CoreBox, CoreTypography } from '@youscience/core';

export const LabelWithDate = ({ label, date }: { label: string; date: string }) => {
  return (
    <CoreBox sx={{ display: 'flex' }}>
      <CoreTypography data-testid={`${label.replaceAll(' ', '')}Label`} sx={{ fontWeight: 'bold' }} variant="body2">
        {label}:&nbsp;
      </CoreTypography>

      <CoreTypography data-testid={`${label.replaceAll(' ', '')}Date`} variant="body2">
        {date}
      </CoreTypography>
    </CoreBox>
  );
};
